var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component, Fragment } from 'react';
import { resolveIcon } from '../../../utils';
import { Cell, Icon } from './components';
import { isNil, isEmpty } from 'ramda';
export var createCell = function createCell(theme, config) {
  var title = config.title,
      _onClick = config.onClick,
      isBold = config.isBold,
      colour = config.colour,
      position = config.position;
  var hasIcon = !isNil(config.icon) && !isEmpty(config.icon);
  var icon = hasIcon ? resolveIcon(theme, config.icon) : '';
  var boldClass = isBold ? 'cell bold' : 'cell';
  return React.createElement(Cell, _extends({
    className: boldClass,
    onClick: function onClick() {
      return _onClick ? _onClick : {};
    },
    hasIcon: hasIcon,
    isDynamic: !isNil(_onClick) && !isEmpty(_onClick)
  }, config), hasIcon && React.createElement(Fragment, null, React.createElement(Icon, {
    icon: icon
  }), React.createElement('div', {
    className: 'title'
  }, title)), !hasIcon && React.createElement('span', null, title));
};
export var toggleDetailsClass = function toggleDetailsClass(isDropdownOpen) {
  return isDropdownOpen ? 'dropdown-open' : 'dropdown-closed';
};